<template>
  <div>
    <div class="container-fixed offset-top-1">
      <div style="float: left" class="offset-right-2">
        <p><b>Group:</b></p>
        <div class="btn-sectioned">
          <router-link v-for="item in parentItems" :key="item.name" :to="{ name: item.name }" active-class="active" class="btn btn-default">
            {{ format(item.name) }}
          </router-link>
        </div>
      </div>
      <div style="float: left">
        <p><b>Test:</b></p>
        <div class="btn-sectioned">
          <router-link v-for="item in items" :key="item.name" :to="{ name: item.name }" exact-active-class="active" class="btn btn-default">
            {{ format(item.name) }}
          </router-link>
        </div>
      </div>
    </div>

    <hr />

    <router-view></router-view>
  </div>
</template>

<script>
import { TEST } from '@route-types';
import { flatRoutes, parents } from '@/utils/navigation';

export default {
  name: 'TestGroups',

  data() {
    return {
      items: [],
      parentItems: [],
    };
  },

  watch: {
    $route: {
      handler: 'onRouteChanged',
      immediate: true,
    },
  },

  created() {
    this.$router.options.routes
      .find(r => r.name === TEST)
      .children.forEach(c => {
        this.parentItems.push(c);
      });
  },

  methods: {
    format(name) {
      name = name.substring(5).toLowerCase();
      return name;
    },

    onRouteChanged() {
      this.items = flatRoutes[this.$route.name].children || flatRoutes[parents[this.$route.name]].children;
    },
  },
};
</script>
